import {Field, InjectedFormProps, reduxForm, submit} from "redux-form";
import {FC, useMemo, useState} from "react";
import TextInput from "../../pages/teams/TeamEditNew/components/fields/TextInput";
import {useTranslation} from "react-i18next";
import {Divider, MainTitle} from "../../pages/CompetitionApplicationForm/components/styles";
import {BrgButton, ButtonVariant, FlexBox} from "@brg/ui";
import {useSelector} from "react-redux";
import imageArrayUploadField from "../../pages/CompetitionApplicationForm/components/fields/ImageArrayUploadField";
import dropdownField from "../../pages/CompetitionApplicationForm/components/fields/DropdownField";
import { API, Endpoints, Lang } from "@brg/api";
import DateInput from "shared/pages/teams/TeamEditNew/components/fields/DateInput";
import { FieldsContainer, OuterContainer, SubmitButton } from "./style";
import { CustomInfoModal } from "../CustomInfoModal/CustomInfoModal";
import validate from "./validate";
import { ApplicationFormSelector } from "shared/reducers/ApplicationFormSlice";
import { ErrorItem } from "shared/pages/projectEdit/styles";
import { useTheme } from "styled-components";
import { CoverField } from "shared/pages/CompetitionApplicationForm/components/fields/CoverField";
import AgreementCheckbox from "./components/AgreementCheckbox";
import GREEN_AWARD_FORMS from "./greenAwardForms";
import { SendButton } from "../styles";

const FORM_COMPONENTS = {
    text: TextInput,
    imageArray: imageArrayUploadField,
    cover: CoverField,
    dropdown: dropdownField,
    date: DateInput,
    agreement: AgreementCheckbox
}

const FORM_NAME = 'application-form';

const ApplicationFormContent: FC<InjectedFormProps> = ({
    // @ts-ignore
    data,
    // @ts-ignore
    competitionId,
    // @ts-ignore
    nominationIds,
    // @ts-ignore
    handleSubmit
}) => {
    const {t, i18n: { language }} = useTranslation();
    const { errors } = useSelector(ApplicationFormSelector);
    const theme = useTheme();
    const [isSend, setIsSend] = useState(false);

    const onSubmit = (data: any) => {
        const confirm = window.confirm('Вы подтверждаете отправку заявки?');

        if (data && confirm) {
            const greenAwardCompetition = GREEN_AWARD_FORMS?.[competitionId];

            const finalData = Object?.entries?.(data)?.reduce((acc, [key,value]) => {
                let newKey = key;
                let newVal = value
                if (['mediaLinks', 'links']?.includes(newKey)) {
                    newVal = [value] 
                }

                return {...acc, [newKey]: newVal }
            } , {})

            API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/AddParticipantRequest')
                .post()
                .body({
                ...finalData,
                competitionId,
                nominationId: nominationIds?.[0],
                formFields: greenAwardCompetition?.fields
            })
            .send()
            .then((response) => {
                if (response?.status === 200) {
                    setIsSend(true);
                }
            })
        // .catch((e) => error(String(e)))
        };
    }

    const fieldList = useMemo(() => {
        return data?.fields?.map(({
            type, 
            label, 
            multiline, 
            multipleValues, 
            name, 
            required, 
            options, 
            max, 
            placeholder, 
            hint, 
            onlyJpgFormat,
            freeTypeIndex,
        }) => (
            <Field
                required={required}
                name={name}
                label={label}
                hint={!!hint ? Lang(hint, language) : undefined}
                multiline={multiline}
                options={options}
                placeholder={placeholder}
                maxLength={max}
                // @ts-ignore
                component={FORM_COMPONENTS[type]}
                onlyJpgFormat={onlyJpgFormat}
                multipleValues={multipleValues}
                freeTypeIndex={freeTypeIndex}
            />
        ))
    }, [data, language])

    const errorsComponents = useMemo(() => {
        if (!errors?.length) return;
        return (
            <FlexBox direction="column" directionMobile='column' offsetTop={48}>
                <ErrorItem
                color={theme.projectEdit.textTips}
                direction="column"
                directionMobile="column"
                >
                <ul>
                    {errors.map((error) => (
                        <li>
                            <FlexBox direction='row'>
                            <span style={{ marginRight: 8 }}>{`—`}</span>
                            <span>{`${error}`}</span>
                            </FlexBox>
                        </li>
                    ))}
                </ul>
                </ErrorItem>
            </FlexBox>
        )
    } , [errors])

    if (isSend) {
        return (
            <OuterContainer>
                <CustomInfoModal 
                    title={t('hse_showcases_title.competitions.msg.success_greenaward_send')}
                    text={t('hse_showcases_title.competitions.msg.success_greenaward_send_descriptions')}
                    subtext={t('hse_showcases_title.competitions.msg.success_greenaward_send_subdescriptions')}
                    fullText
                />
            </OuterContainer>

        )
    }

    return (
        <form /*onSubmit={handleSubmit(onSubmit)}*/>
            <MainTitle>{data.title}</MainTitle>
            <FieldsContainer direction="column" gy={16} gyMobile={16}>
                {fieldList}
                <Divider/>
                {errorsComponents}
                <SendButton
                    variant={ButtonVariant.Filled} 
                    disabled={!!errors?.length} 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        handleSubmit(onSubmit)()
                    }}
                >
                    Отправить
                </SendButton>
            </FieldsContainer>
        </form>
    );
};


export default reduxForm({
    form: FORM_NAME,
    validate
})(ApplicationFormContent);import {Field, InjectedFormProps, reduxForm, submit} from "redux-form";
import {FC, useMemo, useState} from "react";
import TextInput from "../../pages/teams/TeamEditNew/components/fields/TextInput";
import {useTranslation} from "react-i18next";
import {Divider, MainTitle} from "../../pages/CompetitionApplicationForm/components/styles";
import {BrgButton, ButtonVariant, FlexBox} from "@brg/ui";
import {useSelector} from "react-redux";
import imageArrayUploadField from "../../pages/CompetitionApplicationForm/components/fields/ImageArrayUploadField";
import dropdownField from "../../pages/CompetitionApplicationForm/components/fields/DropdownField";
import { API, Endpoints, Lang } from "@brg/api";
import DateInput from "shared/pages/teams/TeamEditNew/components/fields/DateInput";
import { FieldsContainer, OuterContainer, SubmitButton } from "./style";
import { CustomInfoModal } from "../CustomInfoModal/CustomInfoModal";
import validate from "./validate";
import { ApplicationFormSelector } from "shared/reducers/ApplicationFormSlice";
import { ErrorItem } from "shared/pages/projectEdit/styles";
import { useTheme } from "styled-components";
import { CoverField } from "shared/pages/CompetitionApplicationForm/components/fields/CoverField";
import AgreementCheckbox from "./components/AgreementCheckbox";
import GREEN_AWARD_FORMS from "./greenAwardForms";
import { SendButton } from "../styles";

const FORM_COMPONENTS = {
    text: TextInput,
    imageArray: imageArrayUploadField,
    cover: CoverField,
    dropdown: dropdownField,
    date: DateInput,
    agreement: AgreementCheckbox
}

const FORM_NAME = 'application-form';

const ApplicationFormContent: FC<InjectedFormProps> = ({
    // @ts-ignore
    data,
    // @ts-ignore
    competitionId,
    // @ts-ignore
    nominationIds,
    // @ts-ignore
    handleSubmit
}) => {
    const {t, i18n: { language }} = useTranslation();
    const { errors } = useSelector(ApplicationFormSelector);
    const theme = useTheme();
    const [isSend, setIsSend] = useState(false);

    const onSubmit = (data: any) => {
        const confirm = window.confirm('Вы подтверждаете отправку заявки?');

        if (data && confirm) {
            const greenAwardCompetition = GREEN_AWARD_FORMS?.[competitionId];

            const finalData = Object?.entries?.(data)?.reduce((acc, [key,value]) => {
                let newKey = key;
                let newVal = value
                if (['mediaLinks', 'links']?.includes(newKey)) {
                    newVal = [value] 
                }

                return {...acc, [newKey]: newVal }
            } , {})

            API.request()
                .endpoint(Endpoints.competitions)
                .url('/api/Competition/AddParticipantRequest')
                .post()
                .body({
                ...finalData,
                competitionId,
                nominationId: nominationIds?.[0],
                formFields: greenAwardCompetition?.fields
            })
            .send()
            .then((response) => {
                if (response?.status === 200) {
                    setIsSend(true);
                }
            })
        // .catch((e) => error(String(e)))
        };
    }

    const fieldList = useMemo(() => {
        return data?.fields?.map(({
            type, 
            label, 
            multiline, 
            multipleValues, 
            name, 
            required, 
            options, 
            max, 
            placeholder, 
            hint, 
            onlyJpgFormat,
            freeTypeIndex,
        }) => (
            <Field
                required={required}
                name={name}
                label={label}
                hint={!!hint ? Lang(hint, language) : undefined}
                multiline={multiline}
                options={options}
                placeholder={placeholder}
                maxLength={max}
                // @ts-ignore
                component={FORM_COMPONENTS[type]}
                onlyJpgFormat={onlyJpgFormat}
                multipleValues={multipleValues}
                freeTypeIndex={freeTypeIndex}
            />
        ))
    }, [data, language])

    const errorsComponents = useMemo(() => {
        if (!errors?.length) return;
        return (
            <FlexBox direction="column" directionMobile='column' offsetTop={48}>
                <ErrorItem
                color={theme.projectEdit.textTips}
                direction="column"
                directionMobile="column"
                >
                <ul>
                    {errors.map((error) => (
                        <li>
                            <FlexBox direction='row'>
                            <span style={{ marginRight: 8 }}>{`—`}</span>
                            <span>{`${error}`}</span>
                            </FlexBox>
                        </li>
                    ))}
                </ul>
                </ErrorItem>
            </FlexBox>
        )
    } , [errors])

    if (isSend) {
        return (
            <OuterContainer>
                <CustomInfoModal 
                    title={t('hse_showcases_title.competitions.msg.success_greenaward_send')}
                    text={t('hse_showcases_title.competitions.msg.success_greenaward_send_descriptions')}
                    subtext={t('hse_showcases_title.competitions.msg.success_greenaward_send_subdescriptions')}
                    fullText
                />
            </OuterContainer>

        )
    }

    return (
        <form /*onSubmit={handleSubmit(onSubmit)}*/>
            <MainTitle>{data.title}</MainTitle>
            <FieldsContainer direction="column" gy={16} gyMobile={16}>
                {fieldList}
                <Divider/>
                {errorsComponents}
                <SendButton
                    variant={ButtonVariant.Filled} 
                    disabled={!!errors?.length} 
                    onClick={(ev: React.BaseSyntheticEvent) => {
                        ev.preventDefault();
                        handleSubmit(onSubmit)()
                    }}
                >
                    Отправить
                </SendButton>
            </FieldsContainer>
        </form>
    );
};


export default reduxForm({
    form: FORM_NAME,
    validate
})(ApplicationFormContent);